// A prompt's fill-in workspace ([data-prompt-template]): [fields] become inputs,
// and the preview and the copy use their values. Bound once per element.
import { copyText } from './copy'
import { fill, segments } from './placeholders'

export async function flash(button: HTMLButtonElement, result: Promise<boolean>): Promise<void> {
  const label = button.textContent
  button.textContent = (await result) ? 'Copied' : 'Copy failed'
  setTimeout(() => (button.textContent = label), 1600)
}

export function bindPromptWorkspace(workspace: HTMLElement): void {
  if (workspace.dataset.bound) return
  workspace.dataset.bound = '1'

  const template = workspace.dataset.promptTemplate ?? ''
  const preview = workspace.querySelector<HTMLElement>('[data-prompt-preview]')!
  const inputs = [...workspace.querySelectorAll<HTMLInputElement>('[data-placeholder-input]')]
  const values = () => Object.fromEntries(inputs.map((input) => [input.dataset.placeholderInput!, input.value]))

  const render = () => {
    preview.replaceChildren(
      ...segments(template, values()).map((segment) => {
        if (!segment.field) return document.createTextNode(segment.text)
        const mark = document.createElement('mark')
        mark.className = segment.filled ? 'ph filled' : 'ph'
        mark.textContent = segment.text
        return mark
      }),
    )
  }

  inputs.forEach((input) => input.addEventListener('input', render))
  workspace.querySelector<HTMLButtonElement>('[data-prompt-copy]')!.addEventListener('click', (event) => {
    void flash(event.currentTarget as HTMLButtonElement, copyText(fill(template, values())))
  })
  render()
}
